import { render, staticRenderFns } from "./ScholarAdd.vue?vue&type=template&id=fab9022e&lang=pug&"
import script from "./ScholarAdd.vue?vue&type=script&lang=js&"
export * from "./ScholarAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports